<template>
    <div id="log_main" class="ui centered container segment">
        <div class="ui secondary menu">
            <div class="ui secondary center menu">
                <div class="item">
                    <div class="ui search selection dropdown" id="partner_dropdown">
                        <input type="hidden">
                        <i class="dropdown icon"></i>
                        <div class="default text">업체</div>
                        <div class="menu">
                            <div class="item">전체</div>
                            <div class="item" v-for="p in partners" :key="p._id">{{ p.name }}</div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui calendar" id="calendar_start">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="날짜(부터)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui calendar" id="calendar_end">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="날짜(까지)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item" v-if="!isCenter">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui input left icon">
                                <i class="user icon"></i>
                                <input type="text" placeholder="이름" v-model="filter.name" @change="updatePage(1)">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui input left icon">
                                <i class="user icon"></i>
                                <input type="text" placeholder="카테고리" v-model="filter.category" @change="updatePage(1)">
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui input left icon">
                                <i class="user icon"></i>
                                <input type="text" placeholder="내용" v-model="filter.type" @change="updatePage(1)">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui input left icon">
                                <i class="user icon"></i>
                                <input type="text" placeholder="상세내용" v-model="filter.description" @change="updatePage(1)">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <button class="ui teal button" @click="download">다운로드</button>
                </div>
            </div>
        </div>
        <div class="ui secondary menu">
            <div class="ui secondary center menu">
                <div class="item">
                    <div class="ui form">
                        <div class="inline fields">
                            <div class="field">
                                <div class="ui radio checkbox">
                                    <input type="radio" name="type" checked="checked" @click="OnCategoryClick('재고')">
                                    <label>재고</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="ui radio checkbox">
                                    <input type="radio" name="type" @click="OnCategoryClick('업무')">
                                    <label>업무</label>
                                </div>
                            </div>
                            <div class="field" v-if="isHeader">
                                <div class="ui radio checkbox">
                                    <input type="radio" name="type" @click="OnCategoryClick('리뷰')">
                                    <label>설문조사</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scrolling content">
            <table class="ui selectable striped celled compact table">
                <thead>
                    <tr>
                        <th class="collapsing">#</th>
                        <th class="collapsing">날짜</th>
                        <th class="collapsing">이름</th>
                        <!-- <th class="collapsing">카테고리</th> -->
                        <th class="collapsing">내용</th>
                        <th>상세내용</th>
                    </tr>
                </thead>
                <tbody v-if="items.length > 0">
                    <tr v-for="(item, index) in items" :key="item._id">
                        <td class="collapsing">{{ ((page-1) * 100) + index + 1 }}</td>
                        <td class="collapsing">{{ new Date(item.createdAt).format("yyyy-MM-dd(KS) hh:mm") }}</td>
                        <td class="collapsing">{{ item.name }}</td>
                        <!-- <td class="collapsing">{{ item.category }}</td> -->
                        <td class="collapsing">{{ item.type }}</td>
                        <td>{{ item.description }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="ui pagination menu">
                <a class="icon item"><i class="left chevron icon"></i></a>
                <a :class="page === i ? 'active item' : 'item'" v-for="i in totalPages" :key="i" @click="onPageClick(i)">{{ i }}</a>
                <a class="icon item"><i class="right chevron icon"></i></a>
            </div>
        </div>
    </div>
</template>

<script>

const moment = require("moment");

export default {
    data: function() {
        return {
            page: 0, totalPages: 0, prevPage: 0, nextPage: 0, filter: 0, items: 0, test: 0,
            categories: 0, types: 0, 
            userName: 0,
        }
    },
    created: function() {
        this.page = 1;
        this.totalPages = 1;
        this.prevPage = null;
        this.nextPage = null;
        this.dateStart = undefined;
        this.dateEnd = undefined;
        this.filter = {};
        this.filter.category = "재고";
        this.items = [];
        this.userName = "전체";
    },
    mounted: function() {
        this.updatePage(1);
        this.$ui.dropdown("#partner_dropdown", (text) => {
            this.userName = text;
            this.filter._user = this.findUserId(text); this.updatePage(1);
        });
        this.$ui.calendar_StartEnd("#calendar_start", "#calendar_end",
            (date, text) => { this.filter.dateStart = text; },
            (date, text) => { this.filter.dateEnd = text; this.updatePage(1); });
    },
    methods: {
        updatePage(page) {
            if (!this.filter.name) delete this.filter.name;
            if (!this.filter.category) delete this.filter.category;
            if (!this.filter.type) delete this.filter.type;
            if (!this.filter.description) delete this.filter.description;
            if (this.filter.dateStart) { this.filter.dateStart = new Date(this.filter.dateStart); }
            if (this.filter.dateEnd) { this.filter.dateEnd = new Date(this.filter.dateEnd); }

            this.$event.call("openLoading");
            this.$api.getLogPage(this.user._id, page, this.filter, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.items = resData.items;
                    this.page = resData.page;
                    this.totalPages = Math.min(resData.totalPages, 10);
                    this.prevPage = resData.prevPage;
                    this.nextPage = resData.nextPage;

                    this.categories = {};
                    this.types = {};

                    for (const item of this.items) {
                        this.categories[item.category] = item.category;
                        this.types[item.type] = item.type;
                    }
                }
            });
        },
        OnCategoryClick(category) {
            this.filter.category = category;
            this.updatePage(1);
        },
        onPageClick(page) {
            this.updatePage(page);
        },
        onPrevPageClick() {
            if (this.prevPage) { this.updatePage(this.prevPage); }
        },
        onNextPageClick() {
            if (this.nextPage) { this.updatePage(this.nextPage); }
        },
        findUserId(userName) {
            for (const user of this.partners) { if (user.name == userName) return user._id; }
            for (const user of this.centers) { if (user.name == userName) return user._id; }
            for (const user of this.workers) { if (user.name == userName) return user._id; }
            return undefined;
        },
        download() {
            this.$event.call("openLoading");
            this.$api.getAllLogs(this.user._id, this.filter, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    const aoa = [];
                    aoa.push(["#", "날짜", "이름", "카테고리", "내용", "상세내용" ]);

                    let index = 1;
                    for (const item of resData.items) {
                        const createdAtText = new Date(item.createdAt).format("yyyy-MM-dd(KS) hh:mm");
                        aoa.push([ index++, createdAtText, item.name, item.category, item.type, item.description, ]);
                    }

                    const wb = this.$excel.newWorkBook();
                    const ws = this.$excel.addWorkSheet(wb, "sheet", aoa);
                    this.$excel.setColSizes(ws, [ 4, 20, 10, 10, 20, 100 ]);
                    this.$excel.saveFile(wb, this.userName + "_기록");
                }
            });
        },
    },
    computed: {
        isHeader: function() { return this.$store.getters.isHeader; },
        isPartner: function() { return this.$store.getters.isPartner; },
        isCenter: function() { return this.$store.getters.isCenter; },
        user: function() { return this.$store.getters.user; },
        partners: function() { return this.$store.getters.partners; },
        centers: function() { return this.$store.getters.centers; },
        workers: function() { return this.$store.getters.workers; },
        constant: function() { return this.$store.getters.constant; },
        constantNames: function() { return this.$store.getters.constantNames; },
        STATUS_READY: function() { return this.$store.getters.constant.STATUS_READY; },
        STATUS_APPOINTED: function() { return this.$store.getters.constant.STATUS_APPOINTED; },
        STATUS_STARTED: function() { return this.$store.getters.constant.STATUS_STARTED; },
    },
};
</script>

<style>
#log_main {
    overflow: auto;
    min-width: 1500px;
    max-width: 1500px;
    min-height: 700px;
}

#log_main .ui.secondary.menu .item {
    padding: 0;
}

#log_main .ui.grid {
    padding-bottom: 10px;
}

#log_main .ui.grid .ui.dropdown {
    margin-top: 3px;
}

#log_main .ui.table {
    width: 100%;
    padding: 0;
    font-size: 13px;
}

#log_main .ui.table td {
    max-width: 300px;
}

#log_main .ui.text.menu {
    margin: 0;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/LogMain.vue